// extracted by mini-css-extract-plugin
module.exports = {"legal-footer":"LegalFooter-module__legal-footer___2Ao6I"};